import axios from 'axios'
import Moment from 'moment'
import { useEffect, useState } from 'react'
import Calendar from 'react-calendar'
import * as TypIcons from 'react-icons/ti'
import { Link, useNavigate } from 'react-router-dom'
import authService from '../../Components/Login/auth.service'
import {
  ContainerPage,
  TitleOfPage,
  TitlePage1,
  TitlePage2
} from '../../Components/Main'
import ProfileDireita from '../../Components/ProfileDireita'
import SidebarMobile from '../../Components/SideBar-right/SidebarMobile'
import '../../styles/components/Calendar.css'
import '../../styles/pages/relatorio.css'
import ModalEditar from '../MenuDireito/MenuDireito-Modal/ModalEnvioEmail'

function ListagemRelatorio() {
  const dateAtual = new Date()
  if (sessionStorage.DataInicio === undefined) {
    sessionStorage.DataInicio = new Date(
      dateAtual.getFullYear(),
      dateAtual.getMonth(),
      1
    )
    sessionStorage.DataFim = new Date()
  }
  const [date, setDate] = useState([
    Moment(`${sessionStorage.DataInicio} 00:00:00`).isValid()
      ? new Date(`${sessionStorage.DataInicio} 00:00:00`)
      : new Date(sessionStorage.DataInicio),
    Moment(`${sessionStorage.DataFim} 23:59:59`).isValid()
      ? new Date(`${sessionStorage.DataFim} 23:59:59`)
      : new Date(sessionStorage.DataFim)
  ])
  const setSeacrhDate = e => {
    setDate(e)
    sessionStorage.DataInicio = e[0].toISOString().slice(0, 10)
    e[1].setDate(e[1].getDate() - 1)
    sessionStorage.DataFim = e[1].toISOString().slice(0, 10)
    window.location.reload()
  }
  sessionStorage.visualizacao = 'Listagem'
  const history = useNavigate()
  var user = authService.getCurrentUser()
  const [auditorias, setAuditorias] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [notaMin, setNotaMin] = useState(0)
  const [notaMax, setNotaMax] = useState(11)

  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
        '/api/v1/auditoria/list/' +
        user[0].IdEmpresa +
        '/' +
        sessionStorage.IdUnidade +
        '/' +
        sessionStorage.DataInicio +
        '/' +
        sessionStorage.DataFim
      )
      .then(response => {
        setAuditorias(response.data)
      })
  }, [])
  function handleUnidadeChange(event) {
    sessionStorage.visualizacao = event.target.value
    //history('/Relatorio/')
    if (event.target.value === 'Dashboard') {
      history('/Relatorio/')
    }
    else if (event.target.value === 'Listagem') {
      history('/ListagemRelatorio')
    }
    else if (event.target.value === 'Checklist') {
      history('/ListagemChecklistRel')
    }
  }
  function handleToggleComplete() {
    setModalOpen(true)
  }
  const [modalOpen, setModalOpen] = useState(false)
  const [auditoria, setAuditoria] = useState([])
  function handleAuditoria(id, event) {
    if (event.target.checked) {
      const newList = auditoria.filter(item => item.IdRetornoAuditoria !== id)
      const newList2 = newList.concat({
        IdRetornoAuditoria: id
      })
      setAuditoria(newList2)
    } else {
      const newList = auditoria.filter(item => item.IdRetornoAuditoria !== id)
      setAuditoria(newList)
    }
    console.log(auditoria)
  }
  return (
    <div className="displayInteract">
      {modalOpen && (
        <ModalEditar setOpenModal={setModalOpen} auditorias={auditoria} />
      )}
      <ContainerPage>
        <div id="containerHead1">
          <div className="logo" />
        </div>

        <div id="containerHead2">
          <TitleOfPage>
            <TitlePage1>
              {' '}
              {sessionStorage.uniRazaoSocial} / DASHBOARD
            </TitlePage1>
            <Link to="/Home">
              <TitlePage2>Auditorias</TitlePage2>
            </Link>
          </TitleOfPage>
          <div id="containerPesquisaModal">
            <input
              className="fnamePadrao"
              placeholder="Filtrar Local"
              type="text"
              id="fname1"
              name="fname"
              onChange={event => {
                setSearchTerm(event.target.value)
              }}
            />
            <button
              className="buttonModalPadraoPes"
              onClick={handleToggleComplete}
            >
              <TypIcons.TiMail />
            </button>
          </div>
        </div>

        <div className="cxLegendaRel">
          <label htmlFor="" className="lgHLegenda">
            Filtro:
          </label>
          <button
            className="lgHNeutro"
            onClick={event => {
              setNotaMax(11)
              setNotaMin(0)
            }}
          >
            Exibir Todas
          </button>
          <button
            className="lgHAcima"
            onClick={event => {
              setNotaMax(11)
              setNotaMin(8)
            }}
          >
            BOM
          </button>
          <button
            className="lgHMedia"
            onClick={event => {
              setNotaMax(8)
              setNotaMin(6)
            }}
          >
            REGULAR
          </button>
          <button
            className="lgHOrange"
            onClick={event => {
              setNotaMax(6)
              setNotaMin(3)
            }}
          >
            RUIM
          </button>
          <button
            className="lgHAbaixo"
            onClick={event => {
              setNotaMax(3)
              setNotaMin(0)
            }}
          >
            INACEITÀVEL
          </button>
        </div>

        <div className="tabelaPadrao">
          <table>
            <thead>
              <th>Local</th>
              <th>Data de Execusão</th>
              <th>Nota</th>
              <th>Indicador</th>
              <th>Envio</th>
            </thead>
            {auditorias
              .filter(val => {
                if (
                  searchTerm === '' &&
                  parseInt(val.audNota) >= notaMin &&
                  parseInt(val.audNota) < notaMax && val.IdUnidade == sessionStorage.IdUnidade
                ) {
                  return val
                } else if (searchTerm === '' && !parseInt(val.audNota) && val.IdUnidade == sessionStorage.IdUnidade) {
                  return val
                } else if (
                  val.locDescricao
                    .toLowerCase()
                    .includes(searchTerm.toLowerCase()) &&
                  parseInt(val.audNota) >= notaMin &&
                  parseInt(val.audNota) < notaMax && val.IdUnidade == sessionStorage.IdUnidade
                ) {
                  return val
                }
              })
              .map(auditoria => (
                <tbody>
                  <tr>
                    <td>
                      {auditoria.locDescricao}
                    </td>
                    <td>
                      <p className="SpaceDate">{auditoria.audIniciadoEm}</p>
                    </td>
                    <td>
                      {auditoria.audNota}
                    </td>
                    <td>
                      {' '}
                      <a
                        href={`http://cozinhaesaude.hitperformance.com.br/RelatorioAuditoria/${auditoria.audCodigoGUID}`}
                        target={'_blank'}
                      >
                        {/* <a
                        href={`http://ws.hitperformance.com.br/Cozinha/RelatorioAuditoria?id=${auditoria.IdRetornoAuditoria}`}
                        target={'_blank'}
                      ></a> */}

                        <div
                          className={`class-${parseInt(auditoria.audNota) < 3
                            ? 'red1'
                            : parseInt(auditoria.audNota) < 6 &&
                              parseInt(auditoria.audNota) >= 3
                              ? 'orange1'
                              : parseInt(auditoria.audNota) < 8 &&
                                parseInt(auditoria.audNota) >= 6
                                ? 'yellow1'
                                : 'green1'
                            }`}
                        >
                          <TypIcons.TiDocumentText />
                        </div>
                      </a>
                    </td>
                    <td>
                      <div>
                        <input
                          className="CheckAcess"
                          type="checkbox"
                          key={auditoria.IdRetornoAuditoria}
                          onChange={event =>
                            handleAuditoria(auditoria.IdRetornoAuditoria, event)
                          }
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              ))}
          </table>
        </div>
      </ContainerPage>

      {/* MENU LATERAL */}
      <nav className="esconderFiltro">
        <ProfileDireita />
        <div className="calendarRelatorio2">
          <form action="">
            <h1>Selecione:</h1>
            <label htmlFor="">Visualização:</label>
            <select
              name="IdUnidade"
              onChange={event => {
                handleUnidadeChange(event)
              }}
              selected={'Listagem' === sessionStorage.visualizacao}
            >
              <option value={'Listagem'}>Listagem</option>
              <option value={'Dashboard'}>Dashboard</option>
              <option value={'Checklist'}>Checklist</option>

            </select>
            <label htmlFor="">Período:</label>
            <Calendar
              type="Hebrew"
              onChange={setSeacrhDate}
              value={date}
              selectRange={true}
            />
          </form>
        </div>
      </nav>

    </div>
  )
}

export default ListagemRelatorio
